import { useSetAtom, useAtomValue } from "jotai";
import {
  documentsAtom,
  isAttachingAtom,
  isDocumentUploadOpenAtom,
  selectedModalIdAtom,
  openDocumentUploadAtom,
  closeDocumentUploadAtom,
  uploadDocumentAtom,
  addDocumentUploadAtom,
  clearDocumentUploadAtom,
  removeDocumentAtom,
  setIsAttachingAtom,
  updateDeductionAtom,
} from "@/presentation/deduction/components/DeductionDrawer/DeductionInformation/DocumentUpload/atom/documentUpload";

function useDeductionDocumentUpload() {
  const isDocumentUploadOpen = useAtomValue(isDocumentUploadOpenAtom);
  const documents = useAtomValue(documentsAtom);
  const isAttaching = useAtomValue(isAttachingAtom);
  const selectedModalId = useAtomValue(selectedModalIdAtom);

  const openDocumentUpload = useSetAtom(openDocumentUploadAtom);
  const closeDocumentUpload = useSetAtom(closeDocumentUploadAtom);                                                                                                      
  const addDocumentUpload = useSetAtom(addDocumentUploadAtom);
  const clearDocumentUpload = useSetAtom(clearDocumentUploadAtom);
  const uploadDocument = useSetAtom(uploadDocumentAtom);
  const removeDocument = useSetAtom(removeDocumentAtom);
  const setIsAttaching = useSetAtom(setIsAttachingAtom);
  const updateDeduction = useSetAtom(updateDeductionAtom);

  return {
    isDocumentUploadOpen,
    selectedModalId,
    documents,
    isAttaching,
    openDocumentUpload,
    closeDocumentUpload,
    addDocumentUpload,
    uploadDocument,
    clearDocumentUpload,
    removeDocument,
    setIsAttaching,
    updateDeduction,
  };
}

export { useDeductionDocumentUpload };
